import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions/extension-manifest';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { LegacyContentMacroParams } from './LegacyContentMacroParams.ts';

export const LegacyContentExtensionHandler: LoadableType<
	ExtensionComponentProps<LegacyContentMacroParams>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LegacyContentExtensionHandler" */ './LegacyContentExtensionHandler.tsx'
			)
		).LegacyContentExtensionHandler,
});
